// extracted by mini-css-extract-plugin
module.exports = {"button":"menu-toggle-module--button--1zk3z"};